import './GenerateContent.svelte.css';
/* src/components/GenerateContent.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import { createEventDispatcher, onMount } from "../../_snowpack/pkg/svelte.js";
import { DialogContent } from "../../_snowpack/pkg/svelte-accessible-dialog.js";
import { ShareButton } from "./index.js";
import { CloseButton } from "./button-elements/index.js";
import { stringifyAreas } from "../utils/jd-stringifier.js";
import { areas } from "../stores/index.js";

function create_default_slot(ctx) {
	let div0;
	let strong;
	let t1;
	let closebutton;
	let t2;
	let div2;
	let textarea;
	let textarea_rows_value;
	let t3;
	let div1;
	let button;
	let t4;
	let t5;
	let sharebutton;
	let t6;
	let p;
	let t7;
	let a;
	let t8;
	let current;
	let mounted;
	let dispose;
	closebutton = new CloseButton({});
	closebutton.$on("click", /*handleClose*/ ctx[3]);

	sharebutton = new ShareButton({
			props: { text: /*formattedText*/ ctx[1] }
		});

	return {
		c() {
			div0 = element("div");
			strong = element("strong");
			strong.textContent = "🗂  Your J.D Index is ready";
			t1 = space();
			create_component(closebutton.$$.fragment);
			t2 = space();
			div2 = element("div");
			textarea = element("textarea");
			t3 = space();
			div1 = element("div");
			button = element("button");
			t4 = text(/*copyButtonText*/ ctx[2]);
			t5 = space();
			create_component(sharebutton.$$.fragment);
			t6 = space();
			p = element("p");
			t7 = text("Finding this app helpful?\n        ");
			a = element("a");
			t8 = text("Tweet about it.");
			attr(div0, "class", "generated-header svelte-c66oyy");
			attr(textarea, "rows", textarea_rows_value = 10);
			attr(textarea, "class", "svelte-c66oyy");
			attr(button, "class", "jd-primary-button svelte-c66oyy");
			toggle_class(button, "success", /*copyButtonText*/ ctx[2] === SUCCESS_BUTTON_TEXT);
			attr(a, "class", "jd-inline-action");
			attr(a, "rel", "external");
			attr(a, "href", TWITTER_SHARE_URL);
			attr(p, "class", "share-cta svelte-c66oyy");
			attr(div1, "class", "generated-actions svelte-c66oyy");
			attr(div2, "class", "generated-body svelte-c66oyy");
		},
		m(target, anchor) {
			insert(target, div0, anchor);
			append(div0, strong);
			append(div0, t1);
			mount_component(closebutton, div0, null);
			insert(target, t2, anchor);
			insert(target, div2, anchor);
			append(div2, textarea);
			set_input_value(textarea, /*formattedText*/ ctx[1]);
			/*textarea_binding*/ ctx[6](textarea);
			append(div2, t3);
			append(div2, div1);
			append(div1, button);
			append(button, t4);
			append(div1, t5);
			mount_component(sharebutton, div1, null);
			append(div1, t6);
			append(div1, p);
			append(p, t7);
			append(p, a);
			append(a, t8);
			current = true;

			if (!mounted) {
				dispose = [
					listen(textarea, "input", /*textarea_input_handler*/ ctx[5]),
					listen(button, "click", /*handleCopy*/ ctx[4])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*formattedText*/ 2) {
				set_input_value(textarea, /*formattedText*/ ctx[1]);
			}

			if (!current || dirty & /*copyButtonText*/ 4) set_data(t4, /*copyButtonText*/ ctx[2]);

			if (dirty & /*copyButtonText, SUCCESS_BUTTON_TEXT*/ 4) {
				toggle_class(button, "success", /*copyButtonText*/ ctx[2] === SUCCESS_BUTTON_TEXT);
			}

			const sharebutton_changes = {};
			if (dirty & /*formattedText*/ 2) sharebutton_changes.text = /*formattedText*/ ctx[1];
			sharebutton.$set(sharebutton_changes);
		},
		i(local) {
			if (current) return;
			transition_in(closebutton.$$.fragment, local);
			transition_in(sharebutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(closebutton.$$.fragment, local);
			transition_out(sharebutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div0);
			destroy_component(closebutton);
			if (detaching) detach(t2);
			if (detaching) detach(div2);
			/*textarea_binding*/ ctx[6](null);
			destroy_component(sharebutton);
			mounted = false;
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let dialogcontent;
	let current;

	dialogcontent = new DialogContent({
			props: {
				class: "jd-dialog-content--w-half jd-generated-detail",
				"aria-label": "Things editor",
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(dialogcontent.$$.fragment);
		},
		m(target, anchor) {
			mount_component(dialogcontent, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const dialogcontent_changes = {};

			if (dirty & /*$$scope, formattedText, copyButtonText, inputEl*/ 519) {
				dialogcontent_changes.$$scope = { dirty, ctx };
			}

			dialogcontent.$set(dialogcontent_changes);
		},
		i(local) {
			if (current) return;
			transition_in(dialogcontent.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(dialogcontent.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(dialogcontent, detaching);
		}
	};
}

const TWITTER_SHARE_URL = "https://twitter.com/intent/tweet?text=Want%20to%20use%20the%20Johnny%20Decimal%20system%20but%20don't%20want%20to%20update%20the%20reordered%20index%20numbers%20manually%20when%20you%20change%20something?%20Use%20this%20generator:%20"; // prettier-ignore
const DEFAULT_BUTTON_TEXT = "copy";
const SUCCESS_BUTTON_TEXT = "copied! 👍🏽";

function instance($$self, $$props, $$invalidate) {
	let $areas;
	component_subscribe($$self, areas, $$value => $$invalidate(7, $areas = $$value));
	let inputEl;
	let formattedText = "";
	let copyButtonText = DEFAULT_BUTTON_TEXT;
	const dispatch = createEventDispatcher();

	const handleClose = () => {
		dispatch("close");
	}; // prettier-ignore

	const handleCopy = () => {
		inputEl.select();
		document.execCommand("copy");
		$$invalidate(2, copyButtonText = SUCCESS_BUTTON_TEXT);

		setTimeout(
			() => {
				$$invalidate(2, copyButtonText = DEFAULT_BUTTON_TEXT);
			},
			1000
		);
	};

	onMount(() => {
		$$invalidate(1, formattedText = stringifyAreas($areas));
	});

	function textarea_input_handler() {
		formattedText = this.value;
		$$invalidate(1, formattedText);
	}

	function textarea_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			inputEl = $$value;
			$$invalidate(0, inputEl);
		});
	}

	return [
		inputEl,
		formattedText,
		copyButtonText,
		handleClose,
		handleCopy,
		textarea_input_handler,
		textarea_binding
	];
}

class GenerateContent extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default GenerateContent;